import { TabbedPage } from "../../components/TabbedPage";
import { PromoCodesPage } from "../promotions/PromoCodesPage";
import { GiftCardsPage } from "../promotions/GiftCardsPage";
import { LoyaltySettingsPage } from "../promotions/LoyaltySettingsPage";

/** Merged Promo Codes + Gift Cards + Loyalty — all three read-gated identically
 * (every app-access role), so no per-tab role filtering is needed; each page's own
 * write controls already gate themselves internally (OWNER/BRANCH_MANAGER). */
export function PromotionsPage() {
  return (
    <TabbedPage
      title="Promotions"
      defaultTab="promo-codes"
      tabs={[
        { key: "promo-codes", label: "Promo Codes", content: <PromoCodesPage /> },
        { key: "gift-cards", label: "Gift Cards", content: <GiftCardsPage /> },
        { key: "loyalty", label: "Loyalty Program", content: <LoyaltySettingsPage /> },
      ]}
    />
  );
}
